import api from 'app/api';
import getAllWithJoin from './get-nested-products-with-join';
import addNestedProduct from './add-nested-product';
import editNestedProduct from './edit-nested-product';
import getNestedProduct from './get-nested-product';
import getNestedProducts from './get-nested-products';

export const nestedProductsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getNestedProductsWithJoin: getAllWithJoin(builder),
        getNestedProducts: getNestedProducts(builder),
        addNestedProduct: addNestedProduct(builder),
        editNestedProduct: editNestedProduct(builder),
        getNestedProduct: getNestedProduct(builder),
    }),
});

export const {
    useGetNestedProductsWithJoinQuery,
    useAddNestedProductMutation,
    useEditNestedProductMutation,
    useGetNestedProductQuery,
    useGetNestedProductsQuery,
} = nestedProductsApi;
